import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoggedinUser } from './login.model';
import { environment } from '../../../environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  cookieValue: string;
  cookieValueRefresh: string;
  userFirstName: any;
  userLastName: any;
  annonymousName: any;
  mobileNumber: any;
  userEmail: any;
  role: string;
  userID: string;
  type: string;
  redirectUrl: string;
  baseUrl = environment.baseUrl;
  errorData: {};
  data: {};

  constructor(
    private http: HttpClient,
    private router: Router
    ) { }

  login(params): Observable<LoggedinUser> {
    console.log('if cndsn ', params)
    var data = `grant_type=password&scope=3&username=${params.username}&password=${params.password}`;
    return this.http.post<LoggedinUser>(`${this.baseUrl}login`, data).pipe(tap(res => {
      localStorage.setItem('access_token', res.data.accessToken)
      localStorage.setItem('refresh_token', res.data.refreshToken)
      localStorage.setItem('user_id', res.data.user_id)
      localStorage.setItem('scope', res.data.scope)
      localStorage.setItem('first', res.data.name.first)
      localStorage.setItem('last', res.data.name.last)
      localStorage.setItem('annonymous', res.data.annonymous_name)
      localStorage.setItem('mobile', res.data.mobile_number)
      localStorage.setItem('user_email', res.data.email)
    }))
  }

  isLoggedIn() {
    this.cookieValue = localStorage.getItem('access_token')
    this.cookieValueRefresh = localStorage.getItem('refresh_token');
    this.userID = localStorage.getItem('user_id')
    this.type = localStorage.getItem('scope')
    this.userFirstName = localStorage.getItem('first')
    this.userLastName = localStorage.getItem('last')
    this.annonymousName = localStorage.getItem('annonymous')
    this.mobileNumber = localStorage.getItem('mobile')
    this.userEmail = localStorage.getItem('user_email')
    return this.cookieValue != null;
  }

  getToken() {
    this.cookieValue = localStorage.getItem('access_token')
    return this.cookieValue;
  }

  getRefreshToken() {
    this.cookieValueRefresh = localStorage.getItem('refresh_token')
    console.log('in refresh function', this.cookieValueRefresh)
    return this.cookieValueRefresh;
  }

  loginRefresh(params) {
    console.log('if cndsn ', params)
    var data = params;
    return this.http.post<LoggedinUser>(`${this.baseUrl}login`, data).pipe(tap(res => {
      // console.log('in login refresh', data)
      localStorage.setItem('access_token', res.data.accessToken)
      console.log('access_token', localStorage.getItem('access_token'))
      localStorage.setItem('refresh_token', res.data.refreshToken)
      console.log('refresh token', localStorage.getItem('refresh_token'))
      localStorage.setItem('user_id', res.data.user_id)
      localStorage.setItem('scope', res.data.scope)
    }))
  }


  logout(): void {
    localStorage.removeItem('access_token')
    localStorage.removeItem('scope')
    localStorage.removeItem('first')
    localStorage.removeItem('last')
    localStorage.removeItem('annonymous')
    localStorage.removeItem('mobile')
    localStorage.removeItem('user_id')
    localStorage.clear();
    this.router.navigate[('')]
    location.replace('')
  }

}
